import { createAction, props } from '@ngrx/store';
import { Approval } from '../interfaces/Approval';

export enum ResidentsActions {
  LOAD_APPROVALS = "[Residents] Load Approvals",
  APPROVALS_LOADED = "[Residents] Approvals Loaded",
}

export const loadApprovals = createAction(
  ResidentsActions.LOAD_APPROVALS,
);

export const approvalsLoaded = createAction(
  ResidentsActions.APPROVALS_LOADED,
  props<{ approvals: Approval[] }>()
);

export const loadApprovalsFailed = createAction(
  "[Residents] Load Approvals Failed",
  props<{ error: string }>()
);




